import { MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES } from '../../pages/ManualVerificationPage/models/IManualVerificationPageModel'

// Enum bezpośrednio związany z Enumem z Alphy. Hogwart.Infrastructure\Enum\CrossService.cs -> CrossServiceResultCode
// Wartości w nim, odpowiadają wybranym wartością z tego enuma
export enum SMS_CODE_STATUSES_FROM_ALPHA {
    OK = "0",
    ALPHA_NOT_READY = "80",
    WRONG_SMS_CODE = "81",
    CLIENT_PESEL_RESERVED = "83",
    CLIENT_PESEL_RESERVED_LIMIT_REACHED = "84",
    ERROR = "99"
} 
   
export interface SignResponse{
    isOk : boolean;
    code: SMS_CODE_STATUSES_FROM_ALPHA;
}

export interface ConfirmManualVerificationDefaultMethodResponse{
    isOk : boolean;
}

export interface IGetWorkingHoursResponse {
    isOk: boolean;
    manualVerificationPageVerificationState: MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES;
    workFrom: string;
}